import React from 'react';
import '../App.css'; // Ensure this file contains the shared styles

const AmericanLaw = () => {
  return (
    <div className="container">
      {/* Introduction Section */}
      <div className="introduction">
        <h1 className="introduction-title">American Law</h1>
        <p className="introduction-text">
          The United States operates under a federal system of law where both federal and state laws govern. 
          The Constitution is the supreme law of the land, and the judicial system is based on common law traditions, 
          with judicial review being a crucial aspect.
        </p>
      </div>

      {/* Key Features Section */}
      <div className="row">
        <div className="column">
          <h3>Constitutional Law</h3>
          <p>The framework of governance and protection of individual rights.</p>
        </div>
        <div className="column">
          <h3>Federal & State Jurisdictions</h3>
          <p>A dual legal system ensuring balance between federal and state powers.</p>
        </div>
      </div>
      <div className="row">
        <div className="column">
          <h3>Bill of Rights</h3>
          <p>Key amendments safeguarding freedom and equality.</p>
        </div>
        <div className="column">
          <h3>Supreme Court Precedents</h3>
          <p>Landmark decisions shaping American law and society.</p>
        </div>
      </div>
    </div>
  );
};

export default AmericanLaw;
